import React from 'react'
import { Modal, Button } from 'antd'
import styled from 'styled-components'
import { INVITE_RECOVERY, inviteSupportMailto } from './inviteRecoveryCopy'

/**
 * Confirm resend for an existing relationship — always shows recipient first.
 * Does not offer recipient change or ownership transfer shortcuts.
 */
const ResendInviteConfirmModal = ({
  visible,
  draft,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  if (!draft) return null

  const supportHref = inviteSupportMailto({
    venueName: draft.venueName,
    accountNumber: draft.accountNumber,
    email: draft.email,
  })

  return (
    <Modal
      visible={visible}
      title='Resend invitation?'
      onCancel={loading ? undefined : onCancel}
      width={480}
      destroyOnClose
      maskClosable={!loading}
      keyboard={!loading}
      footer={[
        <Button key='cancel' onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button
          key='confirm'
          type='primary'
          loading={loading}
          disabled={loading}
          onClick={onConfirm}
        >
          {loading ? 'Sending…' : 'Resend invitation'}
        </Button>,
      ]}
    >
      <Body>
        <p>{INVITE_RECOVERY.RESEND_RECIPIENT_CONFIRM}</p>
        <Rows>
          <Row>
            <Key>Recipient</Key>
            <Val>{draft.email || '—'}</Val>
          </Row>
          <Row>
            <Key>Venue</Key>
            <Val>{draft.venueName || '—'}</Val>
          </Row>
          {draft.accountNumber ? (
            <Row>
              <Key>Account number</Key>
              <Val>{draft.accountNumber}</Val>
            </Row>
          ) : null}
        </Rows>
        <Support>
          If this still fails, <a href={supportHref}>contact OMS support</a> (
          {INVITE_RECOVERY.SUPPORT_EMAIL}).
        </Support>
      </Body>
    </Modal>
  )
}

const Body = styled.div`
  color: #475569;
  font-size: 14px;
  line-height: 1.5;

  p {
    margin: 0 0 12px;
  }
`

const Rows = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 4px 14px;
  margin-bottom: 12px;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }
`

const Key = styled.span`
  color: #64748b;
`

const Val = styled.span`
  color: #0f172a;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
`

const Support = styled.p`
  margin: 0 !important;
  font-size: 12px;
  color: #64748b;

  a {
    color: #2563eb;
  }
`

export default ResendInviteConfirmModal
